import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { DragDropContext, Droppable } from "react-beautiful-dnd";

import "../../styles.scss";
import DnDHeaderItem from "./DnDHeaderItem";
import ColumnSpacer from "../ColumnSpacer";

const DnDHeader = ({
  headerGroups,
  sortableColumns,
  visibleColumns,
  setColumnOrder,
  setResizer,
  resizer,
  setIsPopoverHidden,
  selectable,
  stretchColumnWidth,
}) => {
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list.map(column => column.id));
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const onDragStart = () => {
    setIsPopoverHidden(true);
    currentColOrder.current = visibleColumns;
  };

  const onDragEnd = () => {
    setIsPopoverHidden(false);
  };

  const onDragUpdate = result => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = reorder(
      currentColOrder.current,
      result.source.index,
      selectable && result.destination.index === 0
        ? 1
        : result.destination.index
    );
    setColumnOrder(items);
  };

  const currentColOrder = React.useRef();

  return (
    <thead>
      {headerGroups.map((headerGroup, index) => (
        <DragDropContext
          onDragStart={onDragStart}
          onDragUpdate={onDragUpdate}
          onDragEnd={onDragEnd}
          key={index}
        >
          <Droppable droppableId="droppable" direction="horizontal">
            {(provided, snapshot) => {
              return (
                <tr
                  ref={provided.innerRef}
                  {...headerGroup.getHeaderGroupProps()}
                  {...provided.droppableProps}
                  className={classNames(
                    snapshot.isDraggingOver &&
                      "mydpd-dndtable-dragging-header-row"
                  )}
                  onMouseUp={() => resizer && setResizer(false)}
                >
                  {headerGroup.headers.map((column, index) => (
                    <DnDHeaderItem
                      sortableColumns={sortableColumns}
                      setResizer={setResizer}
                      column={column}
                      key={column.id}
                      index={index}
                    />
                  ))}
                  {provided.placeholder}
                  {!stretchColumnWidth && <ColumnSpacer as="th" />}
                </tr>
              );
            }}
          </Droppable>
        </DragDropContext>
      ))}
    </thead>
  );
};

DnDHeader.propTypes = {
  headerGroups: PropTypes.array,
  sortableColumns: PropTypes.array,
  visibleColumns: PropTypes.array,
  setColumnOrder: PropTypes.func,
  setResizer: PropTypes.func,
  resizer: PropTypes.bool,
  setIsPopoverHidden: PropTypes.func,
  selectable: PropTypes.bool,
  stretchColumnWidth: PropTypes.bool,
};

export default DnDHeader;
